import Component from "../abstracts/Component";

export default class PdpSwatchesRadioGroup extends Component {
  get SELECTORS() {
    return {
      swatchRadioGroup: '[role="radiogroup"]',
      swatchLink: ".pdp__swatch-dot",
    };
  }

  get CLASSES() {
    return {
      iconWishlistEmpty: "icon-wishlist-empty",
      iconWishlistFull: "icon-wishlist-full",
    };
  }

  constructor(compEl) {
    super(compEl);
    this.radioButtons = [];
    this.firstRadioButton = null;
    this.lastRadioButton = null;
  }

  readDOM() {
    return {
      swatchRadioGroup: this.$component.querySelector(
        this.SELECTORS.swatchRadioGroup,
      ),
    };
  }

  setChecked(currentItem) {
    this.dom.swatchRadioGroup.tabIndex = -1;
    for (var i = 0; i < this.radioButtons.length; i++) {
      var rb = this.radioButtons[i];
      rb.setAttribute("aria-checked", "false");
      rb.tabIndex = -1;
    }
    this.currentValue = currentItem.getAttribute("data-value");
    this.dom.swatchRadioGroup.setAttribute("data-value", this.currentValue);

    currentItem.setAttribute("aria-checked", "true");
    currentItem.tabIndex = 0;
    currentItem.focus();
  }

  setCheckedToPreviousItem(currentItem) {
    var index;

    if (currentItem === this.firstRadioButton) {
      this.setChecked(this.lastRadioButton);
    } else {
      index = this.radioButtons.indexOf(currentItem);
      this.setChecked(this.radioButtons[index - 1]);
    }
  }

  setCheckedToNextItem(currentItem) {
    var index;

    if (currentItem === this.lastRadioButton) {
      this.setChecked(this.firstRadioButton);
    } else {
      index = this.radioButtons.indexOf(currentItem);
      this.setChecked(this.radioButtons[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  handleKeydown(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case " ":
      case "Enter":
        this.setChecked(tgt);
        flag = true;
        tgt.querySelector(this.SELECTORS.swatchLink).click();
        break;

      case "Up":
      case "ArrowUp":
      case "Left":
      case "ArrowLeft":
        this.setCheckedToPreviousItem(tgt);
        flag = true;
        break;

      case "Down":
      case "ArrowDown":
      case "Right":
      case "ArrowRight":
        this.setCheckedToNextItem(tgt);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  handleClick(event) {
    this.setChecked(event.currentTarget);
  }

  handleSwatchesRadioGroup() {
    if (this.dom.swatchRadioGroup) {
      debugger;
      const rbs = this.dom.swatchRadioGroup.querySelectorAll("[role=radio]");
      for (var i = 0; i < rbs.length; i++) {
        var rb = rbs[i];

        rb.tabIndex = -1;
        rb.setAttribute("aria-checked", "false");

        rb.addEventListener("keydown", this.handleKeydown.bind(this));
        rb.addEventListener("click", this.handleClick.bind(this));

        this.radioButtons.push(rb);

        if (!this.firstRadioButton) {
          this.firstRadioButton = rb;
        }
        this.lastRadioButton = rb;
      }
      var value = this.dom.swatchRadioGroup.getAttribute("data-value");
      var index = parseInt(value);

      if (value && index >= 0 && index < this.radioButtons.length) {
        this.radioButtons[index].tabIndex = 0;
      } else {
        value = this.firstRadioButton.getAttribute("data-value");
        this.dom.swatchRadioGroup.setAttribute("data-value", value);
        this.firstRadioButton.tabIndex = 0;
      }
    }
  }

  bindEvents() {
    this.handleSwatchesRadioGroup();
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
